'use strict'

const React = require('react')
const createReactClass = require('create-react-class')
const classNames = require('classnames')
const tabOptions = {
  Hotels: require('./homepageProductsNav/hotels.jsx'),
  HotelsWithParking: require('./homepageProductsNav/hotels-with-parking.jsx'),
  Lounges: require('./homepageProductsNav/lounges.jsx'),
  Insurance: require('./homepageProductsNav/insurance.jsx')
}

const HomepageProductsNav = createReactClass({

  getInitialState () {
    return {
      type: 'HotelsWithParking',
      options: tabOptions.HotelsWithParking
    }
  },

  changeBanner (e, type) {
    e.preventDefault()
    if (!tabOptions[ type ]) return false
    this.setState({
      type,
      options: tabOptions[ type ]
    })
    return false
  },

  handleClick (e) {
    const { options } = this.state
    let bannerOptions = options
    window.location = bannerOptions.buttonLink
    e.preventDefault()
  },

  navLink (type, text) {
    const { type: stateType } = this.state
    const active = classNames({
      'active': type === stateType
    })
    return (
      <li>
        <a className={active} href='#' onClick={(event) => this.changeBanner(event, type)}>
          <i className='fa fa-caret-right' />{ text }
        </a>
      </li>
    )
  },

  render () {
    const { type, options } = this.state

    let bannerOptions = options

    return (
      <div id='product-nav' className='row-fluid clearfix'>
        <ul className='col-sm-4'>
          { this.navLink('Hotels', 'Airport Hotels') }
          { this.navLink('HotelsWithParking', 'Airport Hotels with Parking') }
          { this.navLink('Lounges', 'Airport Lounges') }
          { this.navLink('Insurance', 'Travel Insurance') }
        </ul>
        <div className='col-sm-8' id={bannerOptions.idName} onClick={this.handleClick}>
          <div className='tab-pane' id={type}>
            { bannerOptions.lead && bannerOptions.lead }
            { bannerOptions.subLead && bannerOptions.subLead }
            { bannerOptions.subText && bannerOptions.subText }
          </div>
        </div>
      </div>
    )
  }
})

module.exports = HomepageProductsNav



// WEBPACK FOOTER //
// ./_layouts/_templates/_includes/homepageProductsNav.jsx